import React from 'react'
import Homepage from './pages/home'

const App = () => {
  return (
    <Homepage />
  )
}

export default App